import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useContactPersonListStore from "../../store/userContactPersonListStore";
import useApartmentStore from "../../store/useApartmentStore";

const ClearAllStoresOnNavigate = () => {
    const location = useLocation();

    useEffect(() => {
        useContactPersonListStore.getState().clearContactpersonList();
        useApartmentStore.getState().clearApartment();
    }, [location.pathname]);

    return null;
};

export default ClearAllStoresOnNavigate;
